import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorMessage } from "app/shared/services/axios";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { fetchStatementBackupService, fetchStatementDetailService, fetchStatementV2Service } from "../services/statement.service";
import {
  fetchStatementBackupFailure,
  fetchStatementBackupSuccess,
  fetchStatementDetailFailure,
  fetchStatementDetailSuccess,
  fetchStatementV2Failure,
  fetchStatementV2Success,
} from "./actions";
import { FETCH_STATEMENT_BACKUP_REQUEST, FETCH_STATEMENT_DETAIL_REQUEST, FETCH_STATEMENT_V2_REQUEST } from "./actions.type";
import { FetchStatementBackupRequest, FetchStatementDetailRequest, FetchStatementV2Request } from "./types";

function* fetchStatementBackupSaga(action: FetchStatementBackupRequest) {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchStatementBackupService(action));
    console.log("fetchStatementBackup response: ", response);
    if (response.status === 200) {
      yield put(fetchStatementBackupSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(fetchStatementBackupFailure());
    getErrorMessage(e, true);
  }
}

function* fetchStatementV2Saga(action: FetchStatementV2Request) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchStatementV2Service(action));
    console.log("fetchStatementV2 response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchStatementV2Success(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    yield put(fetchStatementV2Failure());
    getErrorMessage(e, true);
  }
}

function* fetchStatementDetailSaga(action: FetchStatementDetailRequest) {
  try {
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchStatementDetailService(action));
    console.log("fetchStatementDetail response: ", response);
    if (response.status === 200) {
      if (response.data.RESULT?.CODE === "E00") {
        yield put(fetchStatementDetailSuccess(response.data.RESPONSEDATA));
      } else {
        yield put(
          fetchStatementDetailFailure({ code: response.data.RESULT?.CODE || "", message: response.data.RESULT?.DESCRIPTION || "" }),
        );
      }
    }
  } catch (e: any | AxiosError) {
    yield put(fetchStatementDetailFailure());
    getErrorMessage(e, true);
  }
}

function* statementSaga() {
  yield all([
    takeLatest(FETCH_STATEMENT_BACKUP_REQUEST, fetchStatementBackupSaga),
    takeLatest(FETCH_STATEMENT_V2_REQUEST, fetchStatementV2Saga),
    takeLatest(FETCH_STATEMENT_DETAIL_REQUEST, fetchStatementDetailSaga),
  ]);
}

export default statementSaga;
